// Aviso discreto arriba (debajo del encabezado) sobre la conexión y los cambios en cola:
//   «Reconectando…» · «No pudimos conectar. Revisa tu internet; seguimos intentando.»
//   «Guardando…» · «Sin conexión, se guardará al reconectar» · «Guardado»
import { useEffect, useState } from "react";
import { Check, CloudOff, Loader2 } from "lucide-react";
import { usePendientes } from "./pendientes";
import { MENSAJE_SIN_CONEXION, useEstadoRed } from "./red";

const GUARDADO_MS = 3500;

export function AvisoConexion() {
  const red = useEstadoRed();
  const cola = usePendientes();
  const [ahora, setAhora] = useState(() => Date.now());
  // «Guardado» se ve unos segundos y se va solo.
  useEffect(() => {
    if (!cola.guardadoEn) return;
    setAhora(Date.now());
    const t = setTimeout(() => setAhora(Date.now()), GUARDADO_MS + 50);
    return () => clearTimeout(t);
  }, [cola.guardadoEn]);

  const n = cola.ops.length;
  const cambios = n === 1 ? "1 cambio" : `${n} cambios`;
  let tono: "info" | "warn" | "ok" = "info";
  let texto: string | null = null;
  let Icono = Loader2;
  if (red.reintentando > 0) {
    texto = n ? `Reconectando… (${cambios} por guardar)` : "Reconectando…";
  } else if (n && cola.guardando) {
    texto = "Guardando…";
  } else if (n) {
    tono = "warn";
    Icono = CloudOff;
    texto = `Sin conexión, se guardará al reconectar (${cambios})`;
  } else if (red.sinConexion) {
    tono = "warn";
    Icono = CloudOff;
    texto = MENSAJE_SIN_CONEXION;
  } else if (cola.guardadoEn && ahora - cola.guardadoEn < GUARDADO_MS) {
    tono = "ok";
    Icono = Check;
    texto = "Guardado";
  }
  return (
    <div className="aviso-red-caja" role="status" aria-live="polite">
      {texto && (
        <div className={"aviso-red " + tono}>
          <Icono size={14} aria-hidden="true" className={Icono === Loader2 ? "gira" : undefined} />
          <span>{texto}</span>
        </div>
      )}
    </div>
  );
}
